import { render, staticRenderFns } from "./transferCompany.vue?vue&type=template&id=0492d15a&scoped=true"
import script from "./transferCompany.vue?vue&type=script&lang=js"
export * from "./transferCompany.vue?vue&type=script&lang=js"
import style0 from "./transferCompany.vue?vue&type=style&index=0&id=0492d15a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0492d15a",
  null
  
)

export default component.exports